module.exports = __webpack_public_path__ + "media/images/samples/news/article-img@2x-047658860f01fb22a0a1d23b27f94012.png";